// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_watcher_title-module__container--ep1U9"};